<div class="d-flex w-100">
  <ng-container *ngIf="typeDimension == typeSignDimensionEnum.Horizontal">
    <!-- NÃO REQUER ALTURA -->
    <ng-container *ngIf="checkedDimensionHorizontalType(horizontalSignalingDimensionSettingTypeEnum.WithoutHeight)">
      <div class="box-dimension">
        <!-- LARGURA -->
        <div class="col-12">
          <label style="width: 80px">Largura (m)*</label>
          <input
            #dimensionX
            type="text"
            mask="separator.5"
            thousandSeparator="."
            decimalMarker=","
            class="form-control"
            [id]="'dimensionXHorizontal' + dimensionHorizontalItem.type + index"
            [(ngModel)]="dimensionHorizontalItem.dimensionX"
            (change)="calculateDimension(undefined)"
          />
        </div>
        <!-- LARGURA -->
      </div>
    </ng-container>
    <!-- NÃO REQUER ALTURA -->

    <!-- REQUER COMPRIMENTO -->
    <ng-container *ngIf="checkedDimensionHorizontalType(horizontalSignalingDimensionSettingTypeEnum.WithHeight)">
      <div class="box-dimension">
        <!-- COMPRIMENTO -->
        <div class="dimension-field">
          <label>Comprimento (m)*</label>
          <input
            type="text"
            #dimensionY
            mask="separator.5"
            thousandSeparator="."
            decimalMarker=","
            class="form-control"
            [id]="'dimensionYHorizontal' + dimensionHorizontalItem.type + index"
            [(ngModel)]="dimensionHorizontalItem.dimensionY"
            (change)="calculateDimension('totalDimensionHorizontal' + dimensionHorizontalItem.type + index)"
          />
        </div>
        <!-- ALTURA -->

        <!-- LARGURA -->
        <h4 class="d-flex align-items-end mx-2 mb-2">x</h4>
        <div class="dimension-field">
          <label>Largura (m)*</label>
          <input
            #dimensionX
            type="text"
            mask="separator.5"
            thousandSeparator="."
            decimalMarker=","
            class="form-control"
            [id]="'dimensionXHorizontal' + dimensionHorizontalItem.type + index"
            [(ngModel)]="dimensionHorizontalItem.dimensionX"
            (change)="calculateDimension('totalDimensionHorizontal' + dimensionHorizontalItem.type + index)"
          />
        </div>
        <!-- LARGURA -->

        <!-- TOTAL -->
        <h4 class="d-flex align-items-end mx-2 mb-2">=</h4>
        <div class="dimension-field">
          <label>Total (m²)*</label>
          <input
            type="text"
            mask="separator.5"
            thousandSeparator="."
            decimalMarker=","
            class="form-control"
            [id]="'totalDimensionHorizontal' + dimensionHorizontalItem.type + index"
            [readonly]="dimensionHorizontalItem.dimensionX || dimensionHorizontalItem.dimensionY"
            [(ngModel)]="dimensionHorizontalItem.dimension"
            (change)="emitDimensionInformation()"
          />
        </div>
        <!-- TOTAL -->
      </div>
      <!-- REQUER ALTURA -->
    </ng-container>
  </ng-container>

  <ng-container *ngIf="typeDimension != typeSignDimensionEnum.Horizontal">
    <!-- ENVOLVENTE -->
    <div class="box-dimension" *ngIf="checkedDimensionType(dimensionInformationEnum.Envolvente)">
      <!-- ALTURA -->
      <div class="dimension-field">
        <label [ngClass]="{ 'label-disabled': checkedDimensionType(dimensionInformationEnum.Efetiva) }">
          Altura (m)*
        </label>
        <input
          type="text"
          #dimensionY
          mask="separator.5"
          thousandSeparator="."
          decimalMarker=","
          class="form-control"
          [id]="'dimensionYEnvolvente' + typeDimension + index"
          [(ngModel)]="dimensionItem.dimensionY"
          (change)="calculateDimension('totalDimensionEnvolvente' + typeDimension + index)"
        />
      </div>
      <!-- ALTURA -->

      <!-- LARGURA -->
      <h4 class="d-flex align-items-end mx-2 mb-2">x</h4>
      <div class="dimension-field">
        <label [ngClass]="{ 'label-disabled': checkedDimensionType(dimensionInformationEnum.Efetiva) }">
          Largura (m)*
        </label>
        <input
          #dimensionX
          type="text"
          mask="separator.5"
          thousandSeparator="."
          decimalMarker=","
          class="form-control"
          [id]="'dimensionXEnvolvente' + typeDimension + index"
          [(ngModel)]="dimensionItem.dimensionX"
          (change)="calculateDimension('totalDimensionEnvolvente' + typeDimension + index)"
        />
      </div>
      <!-- LARGURA -->

      <!-- TOTAL -->
      <h4 class="d-flex align-items-end mx-2 mb-2">=</h4>
      <div class="dimension-field">
        <label [ngClass]="{ 'label-disabled': checkedDimensionType(dimensionInformationEnum.Efetiva) }">
          Total (m²)*
        </label>
        <input
          type="text"
          mask="separator.5"
          thousandSeparator="."
          decimalMarker=","
          class="form-control"
          [id]="'totalDimensionEnvolvente' + typeDimension + index"
          [readonly]="dimensionItem.dimensionX || dimensionItem.dimensionY"
          [(ngModel)]="dimensionItem.dimension"
          (change)="emitDimensionInformation()"
        />
      </div>
      <!-- TOTAL -->
    </div>
    <!-- ENVOLVENTE -->

    <!-- EFETIVA -->
    <div class="box-dimension" *ngIf="checkedDimensionType(dimensionInformationEnum.Efetiva)">
      <!-- DIÂMETRO -->
      <ng-container *ngIf="typeDimension == typeSignDimensionEnum.Circular">
        <div class="col-5 p-0">
          <label>Diâmetro (m)*</label>
          <input
            type="text"
            #dimensionY
            mask="separator.5"
            thousandSeparator="."
            decimalMarker=","
            class="form-control"
            [id]="'diameter' + typeDimension + index"
            [(ngModel)]="dimensionItem.diameter"
            (change)="calculateDimension('totalDimensionEfetiva' + typeDimension + index)"
          />
        </div>
      </ng-container>
      <!-- DIÂMETRO -->

      <!-- ALTURA -->
      <ng-container
        *ngIf="typeDimension == typeSignDimensionEnum.Octagonal || typeDimension == typeSignDimensionEnum.Triangular"
      >
        <div class="col-5 p-0">
          <label>Altura da Sinalização (m)*</label>
          <input
            #dimensionX
            type="text"
            mask="separator.5"
            thousandSeparator="."
            decimalMarker=","
            class="form-control"
            [id]="'sideLength' + typeDimension + index"
            [(ngModel)]="dimensionItem.dimensionY"
            (change)="calculateDimension('totalDimensionEfetiva' + typeDimension + index)"
          />
        </div>
      </ng-container>
      <!-- ALTURA -->

      <!-- LADO -->
      <ng-container *ngIf="typeDimension == typeSignDimensionEnum.Lozenge">
        <div class="col-5 p-0">
          <label>Lado</label>
          <input
            #dimensionX
            type="text"
            mask="separator.5"
            thousandSeparator="."
            decimalMarker=","
            class="form-control"
            [id]="'sideLength' + typeDimension + index"
            [(ngModel)]="dimensionItem.sideLength"
            (change)="calculateDimension('totalDimensionEfetiva' + typeDimension + index)"
          />
        </div>
      </ng-container>
      <!-- LADO -->

      <!-- TOTAL -->
      <h4 class="d-flex align-items-end mx-2" style="height: 60px">=</h4>
      <div class="col-6 p-0">
        <label>Total (m²)*</label>
        <input
          type="text"
          mask="separator.5"
          thousandSeparator="."
          decimalMarker=","
          class="form-control"
          [id]="'totalDimensionEfetiva' + typeDimension + index"
          [readonly]="dimensionItem.dimensionX || dimensionItem.dimensionY"
          [(ngModel)]="dimensionItem.dimension"
          (change)="emitDimensionInformation()"
        />
      </div>
      <!-- TOTAL -->
    </div>
    <!-- EFETIVA -->
  </ng-container>
</div>
